export const FAQS = [
  {
    q: "هل يدعم النظام المرحلة الثانية للفاتورة الالكترونية",
    a: "نعم، متوافق مع متطلبات هيئة الزكاة والضريبة والجمارك.",
  },

  { q: "هل يدعم نقاط البيع؟", a: "واجهة كاشير عربية سريعة وتعدد طرق الدفع." },

  { q: "هل يوجد تدريب ودعم؟", a: "تدريب مبدئي مجاني ودعم عبر واتساب والهاتف." },
  {
    q: "هل أستطيع نقل البيانات؟",
    a: "نوفر قوالب استيراد للبيانات.",
  },
];
